module.exports = __webpack_public_path__ + "img/frToAr.6acfff6d.png";